import { styled } from '@mui/material/styles';
import { Stack, TextField, Typography } from '@mui/material';

const INPUT_HEIGHT = '56px';

export const ParticipantRowContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:first-of-type': {
    paddingTop: '3px'
  }
}));

export const ParticipantRowStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  '& .MuiFormControl-root': {
    flex: 1,
    minWidth: 0
  }
}));

export const RowErrorTypography = styled(Typography)(({ theme }) => ({
  display: 'block',
  paddingTop: theme.spacing(1),
  paddingLeft: `calc(32px + ${theme.spacing(2)})`,
  whiteSpace: 'nowrap',
  color: theme.palette.error.main
}));

export const RowIndexTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: INPUT_HEIGHT,
  minWidth: '32px',
  color: theme.palette.text.secondary
}));

export const RowActionBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: INPUT_HEIGHT
});

export const CountTextField = styled(TextField)({
  width: '100%'
});

export const HiddenFileInput = styled('input')({
  display: 'none'
});

export const ParticipantsListBox = styled('div')({
  width: '100%',
  paddingTop: '3px',
  overflowX: 'hidden'
});
